import React, { useState } from 'react';
import { Home } from './pages/Home';
import { NowPage } from './pages/Now';
import { SpeakingPost } from './pages/SpeakingPost';
import { WritingPost } from './pages/WritingPost';
import { Navigation } from './components/Navigation';
import { useTheme } from './hooks/useTheme';
type Page = {
  type: 'home';
} | {
  type: 'now';
} | {
  type: 'speaking-post';
  slug: string;
} | {
  type: 'writing-post';
  slug: string;
};
export function App() {
  const [currentPage, setCurrentPage] = useState<Page>({
    type: 'home'
  });
  const {
    theme,
    toggleTheme
  } = useTheme();
  const navigateToHome = () => setCurrentPage({
    type: 'home'
  });
  const navigateToNow = () => setCurrentPage({
    type: 'now'
  });
  const navigateToSpeakingPost = (slug: string) => setCurrentPage({
    type: 'speaking-post',
    slug
  });
  const navigateToWritingPost = (slug: string) => setCurrentPage({
    type: 'writing-post',
    slug
  });
  return <div className="min-h-screen bg-background text-foreground antialiased selection:bg-primary/20 selection:text-primary" data-id="element-0">
      <Navigation currentPage={currentPage.type === 'home' ? 'home' : 'now'} onNavigate={page => page === 'home' ? navigateToHome() : navigateToNow()} theme={theme} onToggleTheme={toggleTheme} data-id="element-1" />

      {currentPage.type === 'home' && <Home theme={theme} onNavigateToSpeaking={navigateToSpeakingPost} onNavigateToWriting={navigateToWritingPost} data-id="element-2" />}

      {currentPage.type === 'now' && <NowPage onBack={navigateToHome} data-id="element-3" />}

      {currentPage.type === 'speaking-post' && <SpeakingPost slug={currentPage.slug} onBack={navigateToHome} data-id="element-4" />}

      {currentPage.type === 'writing-post' && <WritingPost slug={currentPage.slug} onBack={navigateToHome} data-id="element-5" />}
    </div>;
}